// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cLvz","controls":"styles_controls__1djkV","charLimit":"styles_charLimit__3ux5m","input":"styles_input__3xyax","send":"styles_send__3U6cF"};